export default __webpack_public_path__ + "static/media/arrowDropdown.9fee8740.svg";